export default __webpack_public_path__ + "static/media/aha-design-element.3d130aed.jpg";